import { CountryNamesApiDTO } from "../dtos/country-names.dto";

export const mapCountryNamesApiDTOtoCountryNames = (
  countryNamesApiDTO: CountryNamesApiDTO["data"]
) => {
  return countryNamesApiDTO.countryNames;
};
